import {jsxs as _jsxs, jsx as _jsx} from "react/jsx-runtime";import {Search as SearchIcon} from '@mui/icons-material'







const SearchBar = (props) => {
  const {searchQuery, onChange} = props
  return (
    _jsxs('div', { className: "ml-2 flex grow items-center rounded-full bg-slate-200 px-4 py-2 outline-1 outline-hidden outline-offset-0 focus-within:outline-sky-500"           , children: [
      _jsx('input', {
        className: "w-full border-none bg-transparent font-sans text-slate-700 text-sm placeholder-slate-800 outline-hidden"       ,
        autoFocus: true,
        autoComplete: "off",
        name: "search",
        placeholder: "Search",
        type: "text",
        onChange: onChange,
        value: searchQuery,}
      )
      , _jsx(SearchIcon, { fontSize: "small", className: "text-slate-600",} )
    ]})
  )
}

export default SearchBar
